import React from 'react';
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import {
    Box,
    Modal,
    Typography
} from "@mui/material";
import loading from "../../assets/social-media.gif";

const LoadingMain = () => {
    const { isOpen, shape, text, maxWidth } = useSelector((state) => state.loadingMain);
    const { t } = useTranslation();

    return (
        <Modal
            open={isOpen}
        >
            <Box
                width="100%"
                height="100%"
                display="flex"
                justifyContent="center"
                alignItems="center"
            >
                <Box
                    width="fit-content"
                    minWidth="160px"
                    minHeight="160px"
                    style={{
                        padding:"32px",
                        borderRadius: shape === "circle" ? "50%" : "16px",
                        backgroundColor:"#ffffff",
                        display:"flex",
                        flexDirection: "column",
                        justifyContent:"center",
                        alignItems:"center",
                        ...shape === "circle" ? {
                            aspectRatio: "1/1",
                        } : {
                            height:"fit-content"
                        }
                    }}
                >
                    <img
                        width="120" 
                        alt="loading" 
                        src={loading} 
                    />
                    <Box maxWidth={maxWidth || "300px"} marginTop="16px">
                        <Typography align='center' fontSize="18px">{
                            text || `${t("Loading")}...`
                        }</Typography>
                    </Box>
                </Box>
            </Box>
        </Modal>
    );
};

export default LoadingMain;